// frontend/src/hooks/useCurrency.js
import { useAuth } from "../context/AuthContext";

const CURRENCY_SYMBOLS = {
  UGX: " ugx", // Changed to lowercase suffix as requested
  KES: "KSh ",
  TZS: "TSh ",
  RWF: "RF ",
  GBP: "£",
  EUR: "€",
  ZAR: "R ",
  NGN: "₦",
  GHS: "GH₵",
  ETB: "Br ",
  ZMW: "K ",
};

export function useCurrency() {
  const { user } = useAuth();
  const currency = user?.shop_currency || "UGX";

  const fmt = (n) => {
    const num = Number(n) || 0;

    // Create number with commas using en-US locale
    const formattedNum = new Intl.NumberFormat("en-US", {
      maximumFractionDigits: 0,
      minimumFractionDigits: 0,
    }).format(num);

    // If it's UGX, append the suffix " ugx"
    if (currency === "UGX") {
      return `${formattedNum}${CURRENCY_SYMBOLS.UGX}`;
    }

    // Fallback for other currencies using prefixes
    const sym = CURRENCY_SYMBOLS[currency] || currency + " ";
    return `${sym}${formattedNum}`;
  };

  return { fmt, currency };
}
